import { forwardRef } from 'react';

import type { HTMLAttributes } from 'react';

type RadioButtonProps = HTMLAttributes<HTMLInputElement> & {
  labelText?: string;
  value?: string;
  name?: string;
  checked?: boolean;
};
export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(function RadioButton(
  props,
  ref,
) {
  const { value, name, labelText, checked, className, ...otherProps } = props;
  return (
    <label>
      <input {...otherProps} type="radio" ref={ref} value={value} name={name} checked={checked} />
      <span>{labelText}</span>
    </label>
  );
});
